/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import { AVAILABILITY_KEY_MAP_FORMAT, MONTH_DAY_YEAR_NUM_FORMAT } from '../../constants';

export class TripItinerary extends React.Component {
    renderItineraryItems(startDate, endDate, items) {
        return (
            <div className="itinerary-item">
                <div className="itinerary-dates">
                    {`${startDate && gnoment(startDate).format('MMM D')} - ${endDate && gnoment(endDate).format('MMM D, YYYY')}`}
                </div>
                <div className="itinerary-list">
                    {items.map((item, index) => {
                        const itemStartDate = gnoment(item.startDate)
                            .utc(true)
                            .format(MONTH_DAY_YEAR_NUM_FORMAT);
                        const itemEndDate = this.props.incrementCheckoutDate
                            ? gnoment(item.endDate)
                                  .utc(true)
                                  .add(1, 'day')
                                  .format(MONTH_DAY_YEAR_NUM_FORMAT)
                            : gnoment(item.endDate)
                                  .utc(true)
                                  .format(MONTH_DAY_YEAR_NUM_FORMAT);

                        return (
                            <div
                                className="itinerary-card"
                                key={`${item.division.id}-${item.startDate}`}
                            >
                                <div className="itinerary-card-index">{index + 1}</div>
                                <div className="itinerary-card-title">
                                    {item.division.name}
                                </div>
                                <div className="itinerary-card-description">{`Check-in: ${itemStartDate} | Check-out: ${itemEndDate}`}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderNoCheckoutDateItem(startDate, item) {
        const itemStartDate = gnoment(item.startDate)
            .utc(true)
            .format(MONTH_DAY_YEAR_NUM_FORMAT);
        return (
            <div className="itinerary-item">
                <div className="itinerary-dates">
                    {startDate && gnoment(startDate).format('MMM D, YYYY')}
                </div>
                <div
                    className="itinerary-card"
                    key={`${item.division.id}-${itemStartDate}`}
                >
                    <div className="itinerary-card-index">1</div>
                    <div className="itinerary-card-title">{item.division.name}</div>
                    <div className="itinerary-card-description">
                        Check-in: {itemStartDate}
                    </div>
                </div>
            </div>
        );
    }

    renderNoCheckoutDate() {
        const item = this.props.itinerary[0];
        const startDate = item.startDate;

        return this.renderNoCheckoutDateItem(startDate, item);
    }

    renderSelection() {
        if (this.props.errors && this.props.errors[0]) {
            return <p>{this.props.errors[0]}</p>;
        }

        if (!this.props.itinerary || this.props.itinerary.length === 0) {
            return <p>Please select an available date to reserve it.</p>;
        }

        if (this.props.renderFullItinerary) {
            return this.renderFullItinerary();
        }
        return this.renderNoCheckoutDate();
    }

    renderFullItinerary() {
        const firstItineraryItem = this.props.itinerary[0];
        const lastItineraryItem = this.props.itinerary[this.props.itinerary.length - 1];

        const startDate = firstItineraryItem.startDate;
        const endDate = this.props.incrementCheckoutDate
            ? gnoment(lastItineraryItem.endDate)
                  .utc(true)
                  .add(1, 'day')
                  .format(AVAILABILITY_KEY_MAP_FORMAT)
            : gnoment(lastItineraryItem.endDate).format(AVAILABILITY_KEY_MAP_FORMAT);

        return this.renderItineraryItems(startDate, endDate, this.props.itinerary);
    }

    renderExistingNoCheckoutDate() {
        const item = this.props.existingItinerary[0];
        const startDate = item.startDate;

        return this.renderNoCheckoutDateItem(startDate, item);
    }

    renderExistingFullItinerary() {
        const firstItineraryItem = this.props.existingItinerary[0];
        const lastItineraryItem =
            this.props.existingItinerary[this.props.existingItinerary.length - 1];

        const startDate = firstItineraryItem.startDate;
        const endDate = this.props.incrementCheckoutDate
            ? gnoment(lastItineraryItem.endDate)
                  .utc(true)
                  .add(1, 'day')
                  .format(AVAILABILITY_KEY_MAP_FORMAT)
            : gnoment(lastItineraryItem.endDate).format(AVAILABILITY_KEY_MAP_FORMAT);

        return this.renderItineraryItems(
            startDate,
            endDate,
            this.props.existingItinerary
        );
    }

    renderExistingItinerary() {
        if (this.props.renderExistingItinerary) {
            return (
                <div>
                    <div className="itinerary-title">Existing Trip Itinerary</div>
                    {this.props.renderFullItinerary
                        ? this.renderExistingFullItinerary()
                        : this.renderExistingNoCheckoutDate()}
                </div>
            );
        }

        return null;
    }

    render() {
        if (!this.props.name) {
            return null;
        }

        return (
            <div className="per-availability-itinerary">
                <h2 className="itinerary-title">Trip Itinerary</h2>
                {this.renderSelection()}
                {this.renderExistingItinerary()}
            </div>
        );
    }
}

TripItinerary.propTypes = {
    name: PropTypes.string,
    itinerary: PropTypes.arrayOf(PropTypes.shape({})),
    errors: PropTypes.arrayOf(PropTypes.string),
    renderFullItinerary: PropTypes.bool,
    existingItinerary: PropTypes.arrayOf(PropTypes.shape({})),
    renderExistingItinerary: PropTypes.bool,
    incrementCheckoutDate: PropTypes.bool,
};

TripItinerary.defaultProps = {
    errors: [],
    renderFullItinerary: true,
    incrementCheckoutDate: false,
};

export default TripItinerary;
